// extracted by mini-css-extract-plugin
export default {"title":"CustomCoverPage_title__KAUt2"};